module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t('pages.createGroup.name')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nameOfGroup),
      expression: "nameOfGroup"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.nameOfGroup)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nameOfGroup = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v(_vm._s(_vm.$t('pages.createGroup.description')) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.descriptionOfGroup),
      expression: "descriptionOfGroup"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.descriptionOfGroup)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.descriptionOfGroup = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox text-center"
  }, [_c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visibility),
      expression: "visibility"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.visibility) ? _vm._i(_vm.visibility, null) > -1 : (_vm.visibility)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.visibility,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.visibility = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.visibility = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.visibility = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('pages.createGroup.visibility')) + "\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dynamic),
      expression: "dynamic"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.dynamic) ? _vm._i(_vm.dynamic, null) > -1 : (_vm.dynamic)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.dynamic,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.dynamic = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.dynamic = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.dynamic = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('pages.createGroup.dynamic')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox text-center"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.public_a),
      expression: "public_a"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.public_a) ? _vm._i(_vm.public_a, null) > -1 : (_vm.public_a)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.public_a,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.public_a = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.public_a = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.public_a = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.$t('pages.createGroup.public')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-offset-2 col-sm-10"
  }, [_c('button', {
    staticClass: "btn btn-app pull-right",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.createNewSubgroup($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(_vm._s(_vm.Create) + "\n        ")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5aed577a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aed577a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/group/CreateSubgroup.vue
// module id = 1404
// module chunks = 1